import { render, staticRenderFns } from "./SaleFilter.vue?vue&type=template&id=550ae031&scoped=true&"
import script from "./SaleFilter.vue?vue&type=script&lang=js&"
export * from "./SaleFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ae031",
  null
  
)

export default component.exports